export class DispatchAndInvoiceRequestModel {
    userC?: string;
    caseCode: string;
    caseType?: string;
    bkSubDivisionUidD: number;
	bkLoadR: number;
}
